import { render, staticRenderFns } from "./UserRequestProcess.vue?vue&type=template&id=f3b4ced4&"
import script from "./UserRequestProcess.vue?vue&type=script&lang=js&"
export * from "./UserRequestProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports